import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { depositListSuccess, depositListFailure } from "../../Action";
import { DEPOSIT_LIST } from "../../Action/actionTypes";
import { notifyError } from "../../../Utils/Helper";

function* depositListRequest(action) {
  try {
    const { per_page, page, date_from, date_to, status,whitelabelId } = action?.payload?.payload || {};
    const { data } = yield API.get(
      `/deposit?per_page=${per_page}&page=${page}&start_date=${date_from}&end_date=${date_to}&status=${status}&whitelabelId=${whitelabelId}`
    );

    if (data?.meta?.code === 200) {
      yield put(depositListSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(depositListFailure());
      notifyError("Invalid Request.");
    }
  } catch (error) {
    yield put(depositListFailure());
    notifyError("Invalid Request.");
  }
}

export function* watchDepositListAPI() {
  yield takeEvery(DEPOSIT_LIST, depositListRequest);
}

export default function* rootSaga() {
  yield all([watchDepositListAPI()]);
}
